"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbStructuredFilter = exports._SbStructuredFilter = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _groupBy = _interopRequireDefault(require("lodash/groupBy"));

var _findLastIndex = _interopRequireDefault(require("lodash/findLastIndex"));

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _shapes = require("../../skybase-core/shapes");

var _3 = require("./..");

var _value = require("../../skybase-core/utils/value");

var _sbLocale = require("../sb-locale");

var _types = require("./types");

var _sbStructuredFilterOperators = require("./sb-structured-filter-operators");

var _constants = require("../sb-date-time/constants");

var _logicalOperator = require("./logical-operator");

var _sbStructuredFilterConstants = require("./sb-structured-filter-constants");

var _sbStructuredFilterUtils = require("./sb-structured-filter-utils");

var _sbStructuredFilterI18n = require("./sb-structured-filter-i18n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ENUM = _sbStructuredFilterConstants.filterTypes.ENUM,
    DATE = _sbStructuredFilterConstants.filterTypes.DATE,
    RANGE = _sbStructuredFilterConstants.filterTypes.RANGE,
    TEXT = _sbStructuredFilterConstants.filterTypes.TEXT,
    FULL_TEXT = _sbStructuredFilterConstants.filterTypes.FULL_TEXT;
var FIRST = _sbStructuredFilterConstants.itemListSteps.FIRST,
    SECOND = _sbStructuredFilterConstants.itemListSteps.SECOND,
    OPERATORS = _sbStructuredFilterConstants.itemListSteps.OPERATORS;
var AND = _sbStructuredFilterConstants.filterOperators.AND,
    OR = _sbStructuredFilterConstants.filterOperators.OR;
var ASC = _sbStructuredFilterConstants.orderTypes.ASC,
    DESC = _sbStructuredFilterConstants.orderTypes.DESC;

var NOOP = function NOOP() {};

var _SbStructuredFilter = /*#__PURE__*/function (_Component) {
  _inherits(_SbStructuredFilter, _Component);

  var _super = _createSuper(_SbStructuredFilter);

  function _SbStructuredFilter(_props) {
    var _this;

    _classCallCheck(this, _SbStructuredFilter);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "handlePopupPosition", function (_ref) {
      var popupWidth = _ref.popupWidth,
          popupOffsetLeft = _ref.popupOffsetLeft,
          filterWidth = _ref.filterWidth;
      var renderPopupOnLeft = _this.state.renderPopupOnLeft;

      if (filterWidth - popupOffsetLeft < popupWidth && !renderPopupOnLeft) {
        _this.setState({
          renderPopupOnLeft: true
        }); // eslint-disable-line

      } else if (filterWidth - popupOffsetLeft >= popupWidth && renderPopupOnLeft) {
        _this.setState({
          renderPopupOnLeft: false
        }); // eslint-disable-line

      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      if (_this.listWrapper && !_this.listWrapper.contains(event.target) && _this.addButton && !_this.addButton.contains(event.target)) {
        _this.setState(_objectSpread({
          itemsListOpen: false
        }, _this.initialState));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnToggleItemsList", function (e) {
      e.nativeEvent.stopImmediatePropagation();

      _this.setState(function (prevState) {
        return _objectSpread({
          itemsListOpen: !prevState.itemsListOpen
        }, _this.initialState);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnItemSelect", function (e, item) {
      e.nativeEvent.stopImmediatePropagation();
      var activeOperator = _this.state.activeOperator;
      var _this$props = _this.props,
          formatOutput = _this$props.sbLocale.format,
          format = _this$props.format,
          locale = _this$props.locale,
          timeZone = _this$props.timeZone;
      var newItem = (0, _sbStructuredFilterUtils.getNewItem)({
        item: item,
        activeOperator: activeOperator,
        dateProps: {
          formatOutput: formatOutput,
          format: format,
          locale: locale,
          timeZone: timeZone
        }
      });

      _this.setState({
        itemsListStep: SECOND,
        activeItem: newItem
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnSaveTag", function (e) {
      e.nativeEvent.stopImmediatePropagation();
      var _this$state = _this.state,
          activeItem = _this$state.activeItem,
          activeItemIndex = _this$state.activeItemIndex,
          tags = _this$state.tags; // If the activeItemIndex is null, new item will be pushed to tags list, otherwise it will change the activeItem.

      var newTags = (0, _sbStructuredFilterUtils.addTag)(tags, activeItem, activeItemIndex);

      _this.setState(_objectSpread({
        tags: newTags,
        itemsListOpen: false
      }, _this.initialState));

      _this.handleOnChange(newTags);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnRemoveTag", function (index) {
      var tags = _this.state.tags;
      var newTags = (0, _sbStructuredFilterUtils.removeTagByIndex)(tags, index);

      _this.setState({
        tags: newTags
      });

      _this.handleOnChange(newTags);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnEditTag", function (e, index) {
      e.nativeEvent.stopImmediatePropagation();
      var tags = _this.state.tags;

      _this.setState({
        activeItem: _objectSpread({}, tags[index]),
        activeItemIndex: index,
        itemsListStep: SECOND,
        itemsListOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBackToList", function (e) {
      e.nativeEvent.stopImmediatePropagation();

      _this.setState({
        itemsListStep: FIRST
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChangeSelectValue", function (event) {
      event.persist();

      _this.setState(function (prevState) {
        var activeItem = prevState.activeItem;
        return {
          activeItem: _objectSpread(_objectSpread({}, activeItem), {}, {
            values: event.target.value
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnRangeChange", function (values) {
      _this.setState(function (prevState) {
        var activeItem = prevState.activeItem;
        return {
          activeItem: _objectSpread(_objectSpread({}, activeItem), {}, {
            values: values
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnTextFilterChange", function (values, partialMatch) {
      _this.setState(function (prevState) {
        var activeItem = prevState.activeItem;
        return {
          activeItem: _objectSpread(_objectSpread({}, activeItem), {}, {
            values: values,
            partialMatch: partialMatch
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDateFilterChange", function (values) {
      _this.setState(function (prevState) {
        var activeItem = prevState.activeItem;
        return {
          activeItem: _objectSpread(_objectSpread({}, activeItem), {}, {
            values: values
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOperatorChange", function (value) {
      if (value) {
        _this.setState(function (prevState) {
          var activeItem = prevState.activeItem,
              itemsListStep = prevState.itemsListStep;
          return {
            activeOperator: value,
            activeItem: activeItem ? _objectSpread(_objectSpread({}, activeItem), {}, {
              operator: value
            }) : activeItem,
            itemsListStep: itemsListStep === OPERATORS ? FIRST : SECOND
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleNegateItem", function () {
      _this.setState(function (prevState) {
        var activeItem = prevState.activeItem;
        return {
          activeItem: _objectSpread(_objectSpread({}, activeItem), {}, {
            negated: !activeItem.negated
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEventBubblingInPopup", function (e) {
      e.nativeEvent.stopImmediatePropagation();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (tags) {
      var _this$props2 = _this.props,
          allowOR = _this$props2.allowOR,
          onChange = _this$props2.onChange,
          outputParams = _this$props2.outputParams,
          timeZone = _this$props2.timeZone;
      var query = (0, _sbStructuredFilterUtils.convertTagsToQuery)(_objectSpread({
        tags: tags,
        timeZone: timeZone,
        allowOR: allowOR
      }, outputParams));
      onChange(query, tags);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnApplyFilter", function () {
      var tags = _this.state.tags;
      var _this$props3 = _this.props,
          onApply = _this$props3.onApply,
          allowOR = _this$props3.allowOR,
          outputParams = _this$props3.outputParams,
          timeZone = _this$props3.timeZone;
      var query = (0, _sbStructuredFilterUtils.convertTagsToQuery)(_objectSpread({
        tags: tags,
        timeZone: timeZone,
        allowOR: allowOR
      }, outputParams));
      onApply(query, tags);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnResetFilter", function () {
      var onReset = _this.props.onReset;

      _this.setState(_objectSpread({
        itemsListOpen: false,
        tags: _this.requiredTags
      }, _this.initialState));

      onReset(_this.requiredTags);
    });

    _defineProperty(_assertThisInitialized(_this), "renderTag", function (tag, index, lastIndex) {
      var firstIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var _ = _this.props.intl.formatMessage;
      var activeItemIndex = _this.state.activeItemIndex;
      var item = tag.item,
          negated = tag.negated,
          values = tag.values,
          operator = tag.operator;
      var openClass = activeItemIndex === index ? 'open' : '';
      var lastClass = index === lastIndex ? 'last' : '';
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: "filter-tag-".concat(operator, "-").concat(index)
      }, index !== firstIndex && /*#__PURE__*/_react.default.createElement(_logicalOperator.LogicalOperator, {
        operator: operator
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "filter-tag ".concat(lastClass, " ").concat(openClass)
      }, !item.required ? /*#__PURE__*/_react.default.createElement("span", {
        className: "close",
        onClick: function onClick() {
          return _this.handleOnRemoveTag(index);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-toast-close"
      })) : /*#__PURE__*/_react.default.createElement(_3.SbHint, {
        position: {
          vertical: 'middle',
          horizontal: 'right'
        },
        hintData: _(_sbStructuredFilterI18n.messages.requiredFilter)
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "required"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-big-attention"
      }))), /*#__PURE__*/_react.default.createElement("span", {
        onClick: function onClick(e) {
          return _this.handleOnEditTag(e, index);
        }
      }, negated && /*#__PURE__*/_react.default.createElement("div", {
        className: "negate"
      }, _(_sbStructuredFilterI18n.messages.NOT)), "".concat(item.label, ":"), /*#__PURE__*/_react.default.createElement("strong", null, !(0, _value.isNullOrUndefined)(values) ? "".concat((0, _sbStructuredFilterUtils.getTagValues)(tag)) : '')), activeItemIndex === index && _this.renderPopup(false)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTags", function () {
      var tags = _this.state.tags;
      var groupedTags = (0, _groupBy.default)(tags, 'operator'); // Render tags in group, if there are two groups already

      if (groupedTags.AND && groupedTags.OR) {
        var tagsWithANDOperator = [];
        var tagsWithOROperator = [];
        var lastANDIndex = (0, _findLastIndex.default)(tags, function (tag) {
          return tag.operator === AND;
        });
        var lastORIndex = (0, _findLastIndex.default)(tags, function (tag) {
          return tag.operator === OR;
        });
        tags.map(function (tag, index) {
          if (tag.operator === AND) {
            tagsWithANDOperator.push(_this.renderTag(tag, index, lastANDIndex, tagsWithANDOperator.length === 0 ? index : 0));
          } else {
            tagsWithOROperator.push(_this.renderTag(tag, index, lastORIndex, tagsWithOROperator.length === 0 ? index : 0));
          }

          return true;
        });
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
          className: "tag-group and"
        }, tagsWithANDOperator), tagsWithANDOperator && tagsWithOROperator && /*#__PURE__*/_react.default.createElement(_logicalOperator.LogicalOperator, {
          className: "group",
          operator: AND
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "tag-group or"
        }, tagsWithOROperator));
      } // Render a simple tags list, without groups


      var lastIndex = tags.length - 1;
      return tags.map(function (tag, index) {
        return _this.renderTag(tag, index, lastIndex);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderItemList", function () {
      var _this$state2 = _this.state,
          activeOperator = _this$state2.activeOperator,
          filters = _this$state2.filters,
          tags = _this$state2.tags;
      var allowDuplicateAND = _this.props.allowDuplicateAND;
      var allowedFilters = allowDuplicateAND ? filters : (0, _sbStructuredFilterUtils.updateFilters)(filters, activeOperator, tags);
      var items = allowedFilters.map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "filter-select-list-item-".concat(index),
          onClick: function onClick(e) {
            return _this.handleOnItemSelect(e, item);
          }
        }, item.label);
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "item-list"
      }, items);
    });

    _defineProperty(_assertThisInitialized(_this), "renderFilterSettingsOperators", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var activeOperator = _this.state.activeOperator;
      return /*#__PURE__*/_react.default.createElement(_sbStructuredFilterOperators.SbStructuredFilterOperators, {
        operators: _this.operators,
        value: value || activeOperator,
        onChange: function onChange(operator) {
          return _this.handleOnOperatorChange(operator);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFilterSettings", function () {
      var allowBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _ = _this.props.intl.formatMessage;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "settings"
      }, allowBack && /*#__PURE__*/_react.default.createElement("div", {
        className: "back-to-list",
        onClick: _this.handleBackToList
      }, "< ".concat(_(_sbStructuredFilterI18n.messages.backToList))), _this.renderFilterSettingsInputs());
    });

    _defineProperty(_assertThisInitialized(_this), "renderFilterSettingsInputs", function () {
      var _this$state3 = _this.state,
          activeItem = _this$state3.activeItem,
          activeItemIndex = _this$state3.activeItemIndex;
      var _this$props4 = _this.props,
          _ = _this$props4.intl.formatMessage,
          format = _this$props4.format,
          locale = _this$props4.locale,
          timeZone = _this$props4.timeZone,
          popupAddButtonTitle = _this$props4.popupAddButtonTitle,
          popupUpdateButtonTitle = _this$props4.popupUpdateButtonTitle,
          sbLocale = _this$props4.sbLocale;
      var active = activeItem;
      var inputs = null;
      var blockLabel = null;
      var blockPartialMatch = false;
      var blockDisablePartialMatch = false;
      var blockNegated = false;
      var blockOperator = AND;
      var blockInfoText = null;

      if (active && active.item) {
        var item = active.item,
            values = active.values,
            partialMatch = active.partialMatch,
            negated = active.negated,
            operator = active.operator;
        var label = item.label,
            options = item.options,
            placeholder = item.placeholder,
            suffix = item.suffix,
            props = item.props,
            disablePartialMatch = item.disablePartialMatch,
            infoText = item.infoText;
        blockLabel = label;
        blockPartialMatch = partialMatch;
        blockNegated = negated;
        blockOperator = operator;
        blockDisablePartialMatch = disablePartialMatch;
        blockInfoText = infoText || null;

        switch (item.type) {
          case ENUM:
            inputs = /*#__PURE__*/_react.default.createElement(_3.SbSelectList, {
              options: options,
              value: values,
              onChange: _this.handleOnChangeSelectValue
            });
            break;

          case RANGE:
            inputs = /*#__PURE__*/_react.default.createElement(_types.RangeType, {
              from: values.from,
              to: values.to,
              suffix: suffix,
              onChange: _this.handleOnRangeChange,
              inputsProps: props,
              formatMessage: _
            });
            break;

          case TEXT:
          case FULL_TEXT:
            inputs = /*#__PURE__*/_react.default.createElement(_types.TextType, {
              value: values,
              placeholder: placeholder,
              disablePartialMatch: blockDisablePartialMatch,
              partialMatch: blockPartialMatch,
              onChange: _this.handleOnTextFilterChange,
              formatMessage: _
            });
            break;

          case DATE:
            inputs = /*#__PURE__*/_react.default.createElement(_types.DateType, {
              values: values,
              onChange: _this.handleOnDateFilterChange,
              formatMessage: _,
              format: format,
              timeZone: timeZone,
              locale: locale,
              sbLocale: sbLocale
            });
            break;

          default:
            inputs = null;
        }
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "filter-settings-inputs"
      }, blockOperator === AND && /*#__PURE__*/_react.default.createElement("div", {
        className: "negate ".concat(blockNegated ? 'active' : ''),
        onClick: _this.handleToggleNegateItem
      }, _(_sbStructuredFilterI18n.messages.NOT)), /*#__PURE__*/_react.default.createElement("div", {
        className: "block-label"
      }, blockLabel), /*#__PURE__*/_react.default.createElement("div", {
        className: "filter-inputs"
      }, inputs), blockInfoText && /*#__PURE__*/_react.default.createElement("div", {
        className: "info-text"
      }, blockInfoText), /*#__PURE__*/_react.default.createElement("div", {
        className: "divider"
      }), /*#__PURE__*/_react.default.createElement(_3.SbButton, {
        onClick: _this.handleOnSaveTag
      }, activeItemIndex === null ? popupAddButtonTitle || _(_sbStructuredFilterI18n.messages.addFilter) : popupUpdateButtonTitle || _(_sbStructuredFilterI18n.messages.changeFilter)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPopup", function () {
      var allowBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _this$state4 = _this.state,
          itemsListStep = _this$state4.itemsListStep,
          renderPopupOnLeft = _this$state4.renderPopupOnLeft,
          tags = _this$state4.tags;
      var currentStep = itemsListStep === OPERATORS ? tags.length === 0 ? FIRST : OPERATORS : itemsListStep; // eslint-disable-line

      var renderList = null;

      switch (currentStep) {
        case FIRST:
          renderList = _this.renderItemList();
          break;

        case SECOND:
          renderList = _this.renderFilterSettings(allowBack);
          break;

        case OPERATORS:
          renderList = _this.renderFilterSettingsOperators();
          break;

        default:
          renderList = null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-filter-popup ".concat(renderPopupOnLeft ? 'left' : ''),
        ref: function ref(wrapper) {
          _this.listWrapper = wrapper;
        },
        onClick: _this.handleEventBubblingInPopup
      }, renderList);
    });

    _defineProperty(_assertThisInitialized(_this), "renderApplyButton", function () {
      var _ = _this.props.intl.formatMessage;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "button-controlls fl-row fl-justify-sb"
      }, /*#__PURE__*/_react.default.createElement(_3.SbButton, {
        onClick: _this.handleOnApplyFilter
      }, _(_sbStructuredFilterI18n.messages.applyFilters)));
    });

    var _2 = _props.intl.formatMessage,
        _filters = _props.filters,
        initialTags = _props.initialTags,
        _formatOutput = _props.sbLocale.format,
        _format = _props.format,
        _locale = _props.locale,
        _timeZone = _props.timeZone;
    _this.initialState = {
      itemsListStep: _props.allowOR ? OPERATORS : FIRST,
      activeItemIndex: null,
      activeItem: null,
      activeOperator: null
    };
    var dateProps = {
      formatOutput: _formatOutput,
      format: _format,
      locale: _locale,
      timeZone: _timeZone
    };
    _this.requiredInitialTags = (0, _sbStructuredFilterUtils.getRequiredInitialTags)({
      initialTags: initialTags,
      filters: _filters,
      dateProps: dateProps
    }); // these tags are the ones for the reset filter but keep the required tags in it.

    _this.requiredTags = (0, _sbStructuredFilterUtils.getRequiredTagsForReset)({
      filters: _filters,
      dateProps: dateProps
    });
    _this.state = _objectSpread(_objectSpread({
      itemsListOpen: false,
      tags: _this.requiredInitialTags.concat(initialTags),
      filters: _filters
    }, _this.initialState), {}, {
      renderPopupOnLeft: false
    });
    _this.className = (0, _classnames.default)('sb-structured-filter', _props.className);
    _this.operators = [{
      operator: AND,
      label: _2(_sbStructuredFilterI18n.messages.AND)
    }, {
      operator: OR,
      label: _2(_sbStructuredFilterI18n.messages.OR)
    }];
    return _this;
  }

  _createClass(_SbStructuredFilter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var tags = this.state.tags;
      var _this$props5 = this.props,
          allowOR = _this$props5.allowOR,
          outputParams = _this$props5.outputParams,
          timeZone = _this$props5.timeZone,
          onInitialTags = _this$props5.onInitialTags;
      var query = (0, _sbStructuredFilterUtils.convertTagsToQuery)(_objectSpread({
        tags: tags,
        timeZone: timeZone,
        allowOR: allowOR
      }, outputParams));
      document.addEventListener('click', this.handleClickOutside);

      if (onInitialTags) {
        onInitialTags(query, tags);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.listWrapper) {
        this.handlePopupPosition((0, _sbStructuredFilterUtils.getPopupRenderPosition)(this.listWrapper));
      }
    } // Handler for positioning the popup based on "if it fits to the box"

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var itemsListOpen = this.state.itemsListOpen;
      var _this$props6 = this.props,
          containerClassName = _this$props6.containerClassName,
          _ = _this$props6.intl.formatMessage,
          showApplyButton = _this$props6.showApplyButton;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('sb-structured-filter-container', containerClassName)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.className
      }, this.renderTags(), /*#__PURE__*/_react.default.createElement("div", {
        className: "filter-add-container ".concat(itemsListOpen ? 'open' : '')
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "sb-btn add-button ".concat(itemsListOpen ? 'sb-btn-active' : ''),
        onClick: this.handleOnToggleItemsList,
        ref: function ref(button) {
          _this2.addButton = button;
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-plus"
      })), itemsListOpen && this.renderPopup())), /*#__PURE__*/_react.default.createElement(_3.SbButton, {
        onClick: this.handleOnResetFilter
      }, _(_sbStructuredFilterI18n.messages.resetFilters))), showApplyButton && this.renderApplyButton());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var filters = nextProps.filters; // update tags data (suffix, defaultValue, options, etc...)

      var tags = prevState.tags.map(function (tag) {
        if (!tag) {
          return tag;
        }

        var filterId = (0, _findIndex.default)(filters, function (filter) {
          return filter.attribute === tag.item.attribute;
        });

        if (filterId !== -1) {
          // we need to remove the required field from the filter array, because it would change all same items to required, it it's set
          // we wan't only one required field of each required filter
          var _filters$filterId = filters[filterId],
              required = _filters$filterId.required,
              changedItem = _objectWithoutProperties(_filters$filterId, ["required"]);

          return _objectSpread(_objectSpread({}, tag), {}, {
            item: _objectSpread(_objectSpread({}, tag.item), changedItem)
          });
        }

        return tag;
      });
      return {
        filters: nextProps.filters,
        tags: tags
      };
    }
  }]);

  return _SbStructuredFilter;
}(_react.Component);

exports._SbStructuredFilter = _SbStructuredFilter;

_defineProperty(_SbStructuredFilter, "propTypes", {
  allowDuplicateAND: _propTypes.default.bool,
  allowOR: _propTypes.default.bool,
  className: _propTypes.default.string,
  containerClassName: _propTypes.default.string,
  filters: _propTypes.default.arrayOf(_propTypes.default.object),
  outputParams: _propTypes.default.shape({
    from: _propTypes.default.number,
    size: _propTypes.default.number,
    orderBy: _propTypes.default.oneOf([ASC, DESC]),
    orderField: _propTypes.default.string
  }),
  initialTags: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
  locale: _propTypes.default.string,
  format: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  timeZone: _propTypes.default.string,
  onApply: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onReset: _propTypes.default.func,
  intl: _shapes.intlShape.isRequired,
  showApplyButton: _propTypes.default.bool,
  popupAddButtonTitle: _propTypes.default.string,
  popupUpdateButtonTitle: _propTypes.default.string,
  onInitialTags: _propTypes.default.func,
  sbLocale: _sbLocale.sbLocaleShape.isRequired
});

_defineProperty(_SbStructuredFilter, "defaultProps", {
  allowDuplicateAND: false,
  allowOR: false,
  className: null,
  containerClassName: null,
  filters: [],
  outputParams: {},
  initialTags: [],
  locale: null,
  format: _constants.DEFAULT_FORMAT,
  timeZone: 'UTC',
  showApplyButton: true,
  popupAddButtonTitle: null,
  popupUpdateButtonTitle: null,
  onApply: NOOP,
  onChange: NOOP,
  onReset: NOOP,
  onInitialTags: NOOP
});

var SbStructuredFilter = (0, _sbLocale.injectSbLocale)(_SbStructuredFilter);
exports.SbStructuredFilter = SbStructuredFilter;
//# sourceMappingURL=sb-structured-filter.js.map